export enum DateMaskEnum {
  DDMMYYYYHHMMSS = "DDMMYYYYHHMMSS",
  DDMMYYYYHHMM = "DDMMYYYYHHMM",
  DDMMYYYYHH = "DDMMYYYYHH",
  DDMMYYYY = "DDMMYYYY",
  MMYYYY = "MMYYYY",
  YYYY = "YYYY",
  YY = "YY",
}
